import { updateLocalization } from "@redotech/redo-i18n/i18n";
import { useEffect } from "react";
import { useMerchantInfo } from "../hooks/use-merchant-info";
import { useAuth } from "./auth-provider";

/**
 * Applies the merchant's saved dashboard language once it loads, as the
 * dashboard's LocalizationProvider does. A handoff link's language was already
 * applied and saved at startup, so it is left in place.
 */
export function useSetupLocalization(): void {
  const auth = useAuth();
  const { merchantInfo, preferredLocale } = useMerchantInfo();
  const loaded = !!merchantInfo;
  const hasLinkLocale = !!auth?.linkLocale;

  useEffect(() => {
    if (loaded && !hasLinkLocale) {
      updateLocalization(true, preferredLocale);
    }
  }, [hasLinkLocale, loaded, preferredLocale]);
}
